import { useFormContext } from 'react-hook-form';

import { useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { CommentsDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/comments/comments.desktop';
import { userMentionMapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/Comments/Comments.module.scss';

export const Comments = () => {
    const { options } = useAssigneeOptionsList();
    const { watch } = useFormContext<Risk>();

    const mappedOptions = options.map((item) => userMentionMapper(item.assignee));

    return (
        <div className={classes.comments}>
            <CommentsDesktop
                id={watch('cardId')}
                isVirtual={false}
                assigneeOptions={mappedOptions}
                enableQuickComments={false}
            />
        </div>
    );
};
